"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, ScrollArea, Separator } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

const tags = Array.from({ length: 50 }).map(
  (_, i, a) => `Item ${a.length - i}`
);

export default function DocsComponentsScrollArea() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Scroll Area
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A custom scrollable area with native scrolling and consistent styling across browsers.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/scroll-area" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>A scrollable list of items</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <ScrollArea className="h-72 w-48 rounded-md border">
            <div className="p-4">
              <h4 className="mb-4 text-sm font-medium leading-none">Tags</h4>
              {tags.map((tag) => (
                <React.Fragment key={tag}>
                  <div className="text-sm">{tag}</div>
                  <Separator className="my-2" />
                </React.Fragment>
              ))}
            </div>
          </ScrollArea>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">className</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Container classes (set height here)</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">orientation</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">"vertical" | "horizontal"</td>
                <td className="py-2 text-muted-foreground">Scroll direction</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
